

import { ITransport,IKosztyTransportu } from "./ITransport"
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import { Next, Route } from 'vue-router';
import { TransportSvc } from "./TransportSvc"
import { transport_api } from "./ITransportSvc"
import { Finder } from "../../src/finder/IFinder";


import ButtonVue from "@/lib/Button.vue";

@Component({
        async beforeRouteEnter(to: Route, from: Route, next: Next<TransportVue>) {
            console.log("beforeRouteEnter:", to.path)
            next((vm: TransportVue) => { vm.tree_id = to.params.id });
        },
      components: { ButtonVue }
})

export default class TransportVue extends Vue {
  key:number=0;
  tree_id:any;
  transport: ITransport|undefined = undefined;


  async mounted() {
    await this.refresh()
 
    bus.register("kod_pocztowy_selected", this.kod_pocztowy_selected);

  }

   beforeDestroy() {
    bus.remove("kod_pocztowy_selected", this.kod_pocztowy_selected);
  }

  async calc_koszty() {
    
    if (!this.transport) return;
    const transport = <ITransport> await new TransportSvc().calc_koszty( this.transport)
    if (transport) this.transport=transport;
    this.key++
  }

  async chg() {
    await this.calc_koszty();

  }

  async save() {
    if (!this.transport) return;
    const transport = <ITransport> await new TransportSvc().update( this.transport )
    if (transport) this.transport=transport;
    this.key++
  }

  async refresh() {
    if (!this.tree_id) return;
    const transport = <ITransport> await new TransportSvc().find_by_id( this.tree_id )
       if (transport && !transport?.kod_pocztowy_finder) transport.kod_pocztowy_finder=new Finder()
    console.log(transport)
    if (transport) this.transport=transport;
    this.key++
  }

  async kod_pocztowy_selected() {
    //kod_pocztowy='DE 06886'
    await this.chg()
  }

}

